import { useTranslation } from "react-i18next";

/**
 * 승인대기(is_confirmed=false) 배너용 오버레이.
 * 이미지 영역(relative) 안에 absolute 로 올려 반투명 처리 + 실제 고무도장(스탬프) 워터마크.
 *  - 도장 디자인은 운영 요구사항(#329) 첨부 이미지에서 추출한 흰색 원형 빈티지 스탬프(public/pending-stamp.png).
 *  - 흰 잉크라 어느 배너 위에서도 보이도록 약한 그림자 + 살짝 투명 처리.
 * 비활성(is_active=false) 배너는 애초에 목록에 미노출 → 이 오버레이는 승인대기 전용.
 */
export default function PendingApprovalOverlay() {
  const { t } = useTranslation();
  const src = `${process.env.PUBLIC_URL || ""}/pending-stamp.png`;
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/65 pointer-events-none">
      <img
        src={src}
        alt={t("banner.pending_approval") || "승인대기"}
        className="w-[41%] max-w-[147px] object-contain select-none"
        style={{ opacity: 0.92, filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.45))" }}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
